// extracted by mini-css-extract-plugin
export default {"link":"LinkButton_link__6ENvd","link-color":"LinkButton_link-color__KvmQ7","icon":"LinkButton_icon__OAJPi"};